import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import Signup from "./Signup";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col
} from "reactstrap";
import Header from "../Header/Header";
import { TableHeader, Pagination, Search } from "../../DataTable"
import useFullPageLoader from "../../hooks/useFullPageLoader"
import Baja from "../../views/Baja";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ListadoUsuarios() {
  const { user } = useContext(AuthContext);
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const [usuarios, setUsuarios] = useState([]);

  //--- Pagination
const [comments, setComments] = useState([]);
const [loader, showLoader, hideLoader] = useFullPageLoader();
const [totalItems, setTotalItems] = useState(0);
const [currentPage, setCurrentPage] = useState(1);
const [search, setSearch] = useState("");
const [sorting, setSorting] = useState({ field: "", order: "" });
const [activo, setActivo] = useState("");
const ITEMS_PER_PAGE = 50

const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
const URL_AREAS = process.env.REACT_APP_URL_AREAS;
const [idEdit, setIdEdit] = useState();
const [nombre, setNombre] = useState();
const [apellido, setApellido] = useState();
const [email, setEmail] = useState();
const [is_active, setIsActive] = useState();
const [planteles, setPlanteles] = useState([]);
const [plantel, setPlantel] = useState();
const [areas, setAreas] = useState([]);
const [area, setArea] = useState("");

const [idPermisos, setIdPermisos] = useState();
const [menu_planteles, setMenuPlanteles] = useState();
const [menu_areas, setMenuAreas] = useState();

const [menu_admin, setMenuAdmin] = useState();
const [estado_cuenta_vendedores, setEstadoCuentaVendedores] = useState();
const [menu_proveedores, setMenuProveedores] = useState();
const [proveedores_create, setProveedoresCreate] = useState();
const [menu_gastos, setMenuGastos] = useState();
const [gastos_create, setGastosCreate] = useState();
const [gastos_autorizar, setGastosAutorizar] = useState();


const [menu_clientes, setMenuClientes] = useState();
const [clientes_create, setClientesCreate] = useState();
const [clientes_edo_cta, setClientesEdoCta] = useState();
const [menu_catalogos, setMenuCatalogos] = useState();

const [menu_nominas, setMenuNominas] = useState();
const [menu_empleados, setMenuEmpleados] = useState();
const [empleados_create, setEmpleadosCreate] = useState();
const [empleados_sueldo, setEmpleadosSueldo] = useState();
const [menu_puestos, setMenuPuestos] = useState();
const [puestos_create, setPuestosCreate] = useState();
const [nominas_create, setNominasCreate] = useState();
const [nominas_listado, setNominasListado] = useState();
const [nominas_pagos_esp, setNominasPagosEsp] = useState();
const [nominas_pagar, setNominasPagar] = useState();

const [menu_reportes, setMenuReportes] = useState();
const [menu_ingresos, setMenuIngresos] = useState();
const [menu_egresos, setMenuEgresos] = useState();

const [menu_usuarios, setMenuUsuarios] = useState();
const [usuarios_create, setUsuariosCreate] = useState();
const [usuarios_permisos, setUsuariosPermisos] = useState();

const [menu_logs, setMenuLogs] = useState();
const [tipos_telas_create, setTiposTelasCreate] = useState();
const [menu_tipos_telas, setMenuTiposTelas] = useState();
const [colores_create, setColoresCreate] = useState();
const [menu_colores, setMenuColores] = useState();
const [menu_cobradores, setMenuCobradores] = useState();
const [menu_edoCta_Cliente, setMenuEdoCtaCliente] = useState();

const [menu_articulos, setMenuArticulos] = useState();
const [articulos_create, setArticulosCreate] = useState();
const [menu_inventarios, setMenuInventarios] = useState();
const [menu_procesos, setMenuProcesos] = useState();
const [inventarios, setInventarios] = useState();
const [menu_traspasos_salida, setMenuTraspasosSalida] = useState();
const [traspasos_salida_create, setTraspasosSalidaCreate] = useState();
const [cancelar_traspaso_salida, setCancelarTraspasoSalida] = useState();
const [menu_traspasos_entrada, setMenuTraspasosEntrada] = useState();
const [traspasos_entrada_create, setTraspasosEntradaCreate] = useState();
const [menu_compras, setMenuCompras] = useState();
const [menu_oc, setMenuOC] = useState();
const [oc_create, setOCCreate] = useState();
const [compras, setCompras] = useState();
const [compras_create, setComprasCreate] = useState();
const [menu_ventas, setMenuVentas] = useState();
const [ventas_create, setVentasCreate] = useState();
const [menu_pedidos, setMenuPedidos] = useState();
const [pedidos_create, setPedidosCreate] = useState();
const [pedidos_autorizar, setPedidosAutorizar] = useState();
const [menu_devoluciones, setMenuDevoluciones] = useState();
const [menu_devolucionesAdmin, setMenuDevolucionesAdmin] = useState();
const [devoluciones_create, setDevolucionesCreate] = useState();
const [menu_disponible, setMenuDisponible] = useState();
const [disponible_vendedores, setDisponibleVendedores] = useState();
const [surtidos_create, setSurtidosCreate] = useState();
const [menu_surtidos, setMenuSurtidos] = useState();
const [cancelarNotas, setCancelarNotas] = useState();


const [proyeccionEgresos, setProyeccionEgresos] = useState();
const [edoCtaClientes, setEdoCtaClientes] = useState();
const [proyeccionIngresos, setProyeccionIngresos] = useState();
const [altaEvidencia, setAltaEvidencia] = useState();
const [pagoClientes, setPagoClientes] = useState();
const [reporteCobranza, setReporteCobranza] = useState();


const [pendiente_recibir, setPendienteRecibir] = useState();
const [pendiente_embarcar, setPendienteEmbarcar] = useState();
const [embarques, setEmbarques] = useState();
const [faltas_empleados, setFaltasEmpleados] = useState();
const [seguimiento_inventarios, setSeguimientoInventarios] = useState();
const [grupos, setGrupos] = useState();

const [abonos, setAbonos] = useState();
const [abonosCreate, setAbonosCreate] = useState();
const [notasCargo, setNotasCargo] = useState();
const [notasCargoCreate, setNotasCargoCreate] = useState();
const [bonificaciones, setBonificaciones] = useState();
const [bonificacionesCreate, setBonificacionesCreate] = useState();
const [comisiones, setComisiones] = useState();
const [comisionesCreate, setComisionesCreate] = useState();



const [configAdmin, setConfigAdmin] = useState();
const [bancos, setBancos] = useState();
const [cambiaPrecios, setCambiaPrecios] = useState();
const [configuracion, setConfiguracion] = useState();

const [menuCalidad, setMenuCalidad] = useState();
const [calidadCantidad, setCalidadCantidad] = useState();
const [calidadImportes, setCalidadImportes] = useState();

const [menuAnticipos, setMenuAnticipos] = useState();
const [anticiposCreate, setAnticiposCreate] = useState();

const [muestrasEntrada, setMuestrasEntrada] = useState();
const [muestrasEntradaCreate, setMuestrasEntradaCreate] = useState();
const [muestrasSalida, setMuestrasSalida] = useState();
const [muestrasSalidaCreate, setMuestrasSalidaCreate] = useState();
const [ajustesInventario, setAjustesInventario] = useState();
const [autorizarAjustesInventario, setAutorizarAjustesInventario] = useState();


const [pagoProveedores, setPagoProveedores] = useState();
const [pagoProveedoresCreate, setPagoProveedoresCreate] = useState();
const [edoCtaProveedores, setEdoCtaProveedores] = useState();

const [menu_fiscal, setMenuFiscal] = useState();
const [facturasFiscal, setFacturasFiscal] = useState();
const [compPagosFiscal, setCompPagosFiscal] = useState();
const [devolucionesFiscal, setDevolucionesFiscal] = useState();
const [notasCreditoFiscal, setNotasCreditoFiscal] = useState();
const [menu_empresas, setMenuEmpresas] = useState();

const [emailSis, setEmailSis] = useState("admin@lynqroo.com");

const [modal, setModal] = useState(false);
const toggle = () => setModal(!modal);
const [text, setText] = useState(false);

const [modalPermisos, setModalPermisos] = useState(false);
const togglePermisos = () => setModalPermisos(!modalPermisos);

const [selectedStatus, setSelectedStatus] = useState("Si");

  useMemo(() => {
    axios
      .get(`${URL_USERS}Status/${selectedStatus}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allUsuarios = response.data;
        let arrayTabla = allUsuarios
        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
        .map((a) => {
          return {
            _id:a._id,
            nombre: a.nombre,
            apellido: a.apellido,
            email: a.email,
            is_active: a.is_active,
            menu_edoCta_Cliente: a.menu_edoCta_Cliente,
            menu_planteles: a.menu_planteles,
            menu_areas: a.menu_areas,
            menu_admin: a.menu_admin,
            estado_cuenta_vendedores: a.estado_cuenta_vendedores,
            menu_proveedores: a.menu_proveedores,
            proveedores_create: a.proveedores_create,
            menu_gastos: a.menu_gastos,
            gastos_create: a.gastos_create,
            gastos_autorizar: a.gastos_autorizar,
            menu_clientes: a.menu_clientes,
            clientes_create: a.clientes_create,
            clientes_edo_cta: a.clientes_edo_cta,
            menu_catalogos: a.menu_catalogos,
            menu_nominas: a.menu_nominas,
            menu_empleados: a.menu_empleados,
            empleados_create: a.empleados_create,
            empleados_sueldo: a.empleados_sueldo,
            menu_puestos: a.menu_puestos,
            puestos_create: a.puestos_create,
            nominas_create: a.nominas_create,
            nominas_listado: a.nominas_listado,
            nominas_pagos_esp: a.nominas_pagos_esp,
            nominas_pagar: a.nominas_pagar,
            menu_reportes: a.menu_reportes,
            menu_ingresos: a.menu_ingresos,
            menu_egresos: a.menu_egresos,
            menu_usuarios: a.menu_usuarios,
            usuarios_create: a.usuarios_create,
            usuarios_permisos: a.usuarios_permisos,
            menu_logs: a.menu_logs,
            tipos_telas_create: a.tipos_telas_create,
            menu_tipos_telas: a.menu_tipos_telas,
            colores_create: a.colores_create,
            menu_colores: a.menu_colores,
            menu_cobradores: a.menu_cobradores,
            menu_articulos: a.menu_articulos,
            articulos_create: a.articulos_create,
            menu_inventarios: a.menu_inventarios,
            menu_procesos: a.menu_procesos,
            inventarios: a.inventarios,
            menu_traspasos_salida: a.menu_traspasos_salida,
            traspasos_salida_create: a.traspasos_salida_create,
            cancelar_traspaso_salida: a.cancelar_traspaso_salida,
            menu_traspasos_entrada: a.menu_traspasos_entrada,
            traspasos_entrada_create: a.traspasos_entrada_create,
            menu_compras: a.menu_compras,
            menu_oc: a.menu_oc,
            oc_create: a.oc_create,
            compras: a.compras,
            compras_create: a.compras_create,
            menu_ventas: a.menu_ventas,
            ventas_create: a.ventas_create,
            menu_pedidos: a.menu_pedidos,
            pedidos_create: a.pedidos_create,
            pedidos_autorizar: a.pedidos_autorizar,
            menu_devoluciones: a.menu_devoluciones,
            menu_devolucionesAdmin: a.menu_devolucionesAdmin,
            devoluciones_create: a.devoluciones_create,
            menu_disponible: a.menu_disponible,
            disponible_vendedores: a.disponible_vendedores,
            menu_surtidos: a.menu_surtidos,
            surtidos_create: a.surtidos_create,
            pendiente_recibir: a.pendiente_recibir,
            pendiente_embarcar: a.pendiente_embarcar,
            embarques: a.embarques,
            faltas_empleados: a.faltas_empleados,
            seguimiento_inventarios: a.seguimiento_inventarios,
            grupos: a.grupos,
            proyeccionEgresos: a.proyeccionEgresos,
            edoCtaClientes: a.edoCtaClientes,
            cancelarNotas: a.cancelarNotas,
            proyeccionIngresos: a.proyeccionIngresos,
            altaEvidencia: a.altaEvidencia,
            pagoClientes: a.pagoClientes,
            reporteCobranza: a.reporteCobranza,
            configAdmin: a.configAdmin,
            configuracion: a.configuracion,
            bancos: a.bancos,
            cambiaPrecios: a.cambiaPrecios,
            menuCalidad: a.menuCalidad,
            calidadCantidad: a.calidadCantidad,
            calidadImportes: a.calidadImportes,
            menuAnticipos: a.menuAnticipos,
            anticiposCreate: a.anticiposCreate,
            abonos: a.abonos,
            abonosCreate: a.abonosCreate,
            notasCargo: a.notasCargo,
            notasCargoCreate: a.notasCargoCreate,
            bonificaciones: a.bonificaciones,
            bonificacionesCreate: a.bonificacionesCreate,
            comisiones: a.comisiones,
            comisionesCreate: a.comisionesCreate,
            muestrasEntrada: a.muestrasEntrada,
            muestrasEntradaCreate: a.muestrasEntradaCreate,
            muestrasSalida: a.muestrasSalida,
            muestrasSalidaCreate: a.muestrasSalidaCreate,
            pagoProveedores: a.pagoProveedores,
            pagoProveedoresCreate: a.pagoProveedoresCreate,
            edoCtaProveedores: a.edoCtaProveedores,
            ajustesInventario: a.ajustesInventario,
            autorizarAjustesInventario: a.autorizarAjustesInventario,
            menu_fiscal: a.menu_fiscal,
            facturasFiscal: a.facturasFiscal,
            compPagosFiscal: a.compPagosFiscal,
            devolucionesFiscal: a.devolucionesFiscal,
            notasCreditoFiscal: a.notasCreditoFiscal,
            menu_empresas: a.menu_empresas,
          }
        }).filter(function (el) {
          return el != null;
        });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal)
        setUsuarios(allUsuarios);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_PLANTELES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPlanteles = res.data;
        setPlanteles(allPlanteles);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  },[selectedStatus]);

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Apellido", field: "apellido", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments

    if (search) {
        computedComments = computedComments.filter(
            comment =>
                comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
                comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
                comment.apellido.toLowerCase().includes(search.toLowerCase()) ||
                comment.email.toLowerCase().includes(search.toLowerCase())
        );
    }


    if(activo){
      computedComments = computedComments.filter((e)=>
      e.is_active.includes(activo)
      ) 
    } 

    if(emailSis){
      computedComments = computedComments.filter((e)=>
      !e.email.includes(emailSis)
      ) 
    }     

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computedComments = computedComments.sort(
            (a, b) =>
                reversed * a[sorting.field].localeCompare(b[sorting.field])
        );
    }

    //Current Page slice
    return computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
}, [comments, currentPage, search, sorting, activo, email]);

function Edit(idEdit, nombre, apellido, email){
  axios
  .get(`${URL_USERS}/${idEdit}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  }).then((response)=>{
    let usuarioEdit = response.data;
    setPlantel(usuarioEdit.planteles[0]._id)
    setArea(usuarioEdit.areas[0]._id)
  })
  setIdEdit(idEdit)
  setNombre(nombre)
  setApellido(apellido)
  setEmail(email)
  toggle()
}

function editUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idEdit}`,
      {
        nombre,
        apellido,
        email,
        planteles: plantel,
        areas: area,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      toggle();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

function Permisos (
  id, 
  nombre,
  apellido,
  menu_planteles,
  menu_areas,
  menu_admin,
  estado_cuenta_vendedores,
  menu_proveedores,
  proveedores_create,
  menu_gastos,
  gastos_create,
  gastos_autorizar,
  menu_clientes,
  clientes_create,
  clientes_edo_cta,
  menu_catalogos,
  menu_nominas,
  menu_empleados,
  empleados_create,
  empleados_sueldo,
  menu_puestos,
  puestos_create,
  nominas_create,
  nominas_listado,
  nominas_pagos_esp,
  nominas_pagar,
  menu_reportes,
  menu_ingresos,
  menu_egresos,
  menu_usuarios,
  usuarios_create,
  usuarios_permisos,
  menu_logs,
  tipos_telas_create,
  menu_tipos_telas,
  colores_create,
  menu_colores,
  menu_cobradores,
  menu_edoCta_Cliente,
  menu_articulos,
  articulos_create,
  menu_inventarios,
  menu_procesos,
  inventarios,
  menu_traspasos_salida,
  traspasos_salida_create,
  cancelar_traspaso_salida,
  menu_traspasos_entrada,
  traspasos_entrada_create,
  menu_compras,
  menu_oc,
  oc_create,
  compras,
  compras_create,
  menu_ventas,
  ventas_create,
  menu_pedidos,
  pedidos_create,
  pedidos_autorizar,
  menu_devoluciones,
  menu_devolucionesAdmin,
  devoluciones_create,
  menu_disponible,
  disponible_vendedores,
  menu_surtidos,
  surtidos_create,
  pendiente_recibir,
  pendiente_embarcar,
  embarques,
  faltas_empleados,
  seguimiento_inventarios,
  grupos,
  proyeccionEgresos,
  edoCtaClientes,
  cancelarNotas,
  proyeccionIngresos,
  altaEvidencia,
  pagoClientes,
  reporteCobranza,
  configAdmin,
  configuracion,
  bancos,
  cambiaPrecios,
  menuCalidad,
  calidadCantidad,
  calidadImportes,
  menuAnticipos,
  anticiposCreate,
  abonos,
  abonosCreate,
  notasCargo,
  notasCargoCreate,
  bonificaciones,
  bonificacionesCreate,
  comisiones,
  comisionesCreate,
  muestrasEntrada,
  muestrasEntradaCreate,
  muestrasSalida,
  muestrasSalidaCreate,
  pagoProveedores,
  pagoProveedoresCreate,
  edoCtaProveedores,
  ajustesInventario,
  autorizarAjustesInventario,
  menu_fiscal,
  facturasFiscal,
  compPagosFiscal,
  devolucionesFiscal,
  notasCreditoFiscal,
  menu_empresas,
  ){
        setIdPermisos(id)
        setNombre(nombre)
        setApellido(apellido)
        setMenuAdmin(menu_admin)
        setEstadoCuentaVendedores(estado_cuenta_vendedores)
        setMenuNominas(menu_nominas)
        setMenuReportes(menu_reportes)
        setMenuUsuarios(menu_usuarios)
        setMenuPlanteles(menu_planteles)
        setMenuAreas(menu_areas)
        setMenuProveedores(menu_proveedores)
        setMenuGastos(menu_gastos)
        setMenuClientes(menu_clientes)
        setMenuCatalogos(menu_catalogos)
        setMenuEmpleados(menu_empleados)
        setMenuPuestos(menu_puestos)
        setMenuIngresos(menu_ingresos)
        setMenuEgresos(menu_egresos)
        setNominasCreate(nominas_create)
        setProveedoresCreate(proveedores_create)
        setGastosCreate(gastos_create)
        setGastosAutorizar(gastos_autorizar)
        setClientesCreate(clientes_create)
        setClientesEdoCta(clientes_edo_cta)
        setEmpleadosCreate(empleados_create)
        setEmpleadosSueldo(empleados_sueldo)
        setPuestosCreate(puestos_create)
        setNominasListado(nominas_listado)
        setNominasPagosEsp(nominas_pagos_esp)
        setNominasPagar(nominas_pagar)
        setUsuariosCreate(usuarios_create)
        setUsuariosPermisos(usuarios_permisos)
        setMenuLogs(menu_logs)
        setTiposTelasCreate(tipos_telas_create)
        setMenuTiposTelas(menu_tipos_telas)
        setColoresCreate(colores_create)
        setMenuColores(menu_colores)
        setMenuCobradores(menu_cobradores)
        setMenuEdoCtaCliente(menu_edoCta_Cliente)
        setMenuArticulos(menu_articulos)
        setArticulosCreate(articulos_create)
        setMenuInventarios(menu_inventarios)
        setMenuProcesos(menu_procesos)
        setInventarios(inventarios)
        setMenuTraspasosSalida(menu_traspasos_salida)
        setTraspasosSalidaCreate(traspasos_salida_create)
        setCancelarTraspasoSalida(cancelar_traspaso_salida)
        setMenuTraspasosEntrada(menu_traspasos_entrada)
        setTraspasosEntradaCreate(traspasos_entrada_create)
        setMenuCompras(menu_compras)
        setMenuOC(menu_oc)
        setOCCreate(oc_create)
        setCompras(compras)
        setComprasCreate(compras_create)
        setMenuVentas(menu_ventas)
        setVentasCreate(ventas_create)
        setMenuPedidos(menu_pedidos)
        setPedidosCreate(pedidos_create)
        setPedidosAutorizar(pedidos_autorizar)
        setMenuDevoluciones(menu_devoluciones)
        setMenuDevolucionesAdmin(menu_devolucionesAdmin)
        setDevolucionesCreate(devoluciones_create)
        setMenuDisponible(menu_disponible)
        setDisponibleVendedores(disponible_vendedores)
        setMenuSurtidos(menu_surtidos)
        setSurtidosCreate(surtidos_create)
        setPendienteRecibir(pendiente_recibir)
        setPendienteEmbarcar(pendiente_embarcar)
        setEmbarques(embarques)
        setFaltasEmpleados(faltas_empleados)
        setSeguimientoInventarios(seguimiento_inventarios)
        setGrupos(grupos)
        setProyeccionEgresos(proyeccionEgresos)
        setEdoCtaClientes(edoCtaClientes)
        setCancelarNotas(cancelarNotas)
        setProyeccionIngresos(proyeccionIngresos)
        setAltaEvidencia(altaEvidencia)
        setPagoClientes(pagoClientes)
        setReporteCobranza(reporteCobranza)
        setCambiaPrecios(cambiaPrecios)
        setBancos(bancos)
        setConfigAdmin(configAdmin)
        setConfiguracion(configuracion)
        setMenuCalidad(menuCalidad)
        setCalidadCantidad(calidadCantidad)
        setCalidadImportes(calidadImportes)
        setMenuAnticipos(menuAnticipos)
        setAnticiposCreate(anticiposCreate)
        setAbonos(abonos)
        setAbonosCreate(abonosCreate)
        setNotasCargo(notasCargo)
        setNotasCargoCreate(notasCargoCreate)
        setBonificaciones(bonificaciones)
        setBonificacionesCreate(bonificacionesCreate)
        setComisiones(comisiones)
        setComisionesCreate(comisionesCreate)
        setMuestrasEntrada(muestrasEntrada)
        setMuestrasEntradaCreate(muestrasEntradaCreate)
        setMuestrasSalida(muestrasSalida)
        setMuestrasSalidaCreate(muestrasSalidaCreate)
        setPagoProveedores(pagoProveedores)
        setPagoProveedoresCreate(pagoProveedoresCreate)
        setEdoCtaProveedores(edoCtaProveedores)
        setAjustesInventario(ajustesInventario)
        setAutorizarAjustesInventario(autorizarAjustesInventario)
        setMenuFiscal(menu_fiscal)
        setFacturasFiscal(facturasFiscal)
        setCompPagosFiscal(compPagosFiscal)
        setDevolucionesFiscal(devolucionesFiscal)
        setNotasCreditoFiscal(notasCreditoFiscal)
        setMenuEmpresas(menu_empresas)
        togglePermisos()
}

function permisosUsuario(event) {
  event.preventDefault();
  axios
    .patch(
      `${URL_USERS}/${idPermisos}`,
      {
        menu_planteles,
        menu_areas,
        menu_admin,
        estado_cuenta_vendedores,
        menu_proveedores,
        proveedores_create,
        menu_gastos,
        gastos_create,
        gastos_autorizar,
        menu_clientes,
        clientes_create,
        clientes_edo_cta,
        menu_catalogos,
        menu_nominas,
        menu_empleados,
        empleados_create,
        empleados_sueldo,
        menu_puestos,
        puestos_create,
        nominas_create,
        nominas_listado,
        nominas_pagos_esp,
        nominas_pagar,
        menu_reportes,
        menu_ingresos,
        menu_egresos,
        menu_usuarios,
        usuarios_create,
        usuarios_permisos,
        menu_logs,
        tipos_telas_create,
        menu_tipos_telas,
        colores_create,
        menu_colores,
        menu_cobradores,
        menu_edoCta_Cliente,
        menu_articulos,
        articulos_create,
        menu_inventarios,
        menu_procesos,
        inventarios,
        menu_traspasos_salida,
        traspasos_salida_create,
        cancelar_traspaso_salida,
        menu_traspasos_entrada,
        traspasos_entrada_create,
        menu_compras,
        menu_oc,
        oc_create,
        compras,
        compras_create,
        menu_ventas,
        ventas_create,
        menu_pedidos,
        pedidos_create,
        pedidos_autorizar,
        menu_devoluciones,
        menu_devolucionesAdmin,
        devoluciones_create,
        menu_disponible,
        disponible_vendedores,
        menu_surtidos,
        surtidos_create,
        pendiente_recibir,
        pendiente_embarcar,
        embarques,
        faltas_empleados,
        seguimiento_inventarios,
        grupos,
        proyeccionEgresos,
        edoCtaClientes,
        cancelarNotas,
        proyeccionIngresos,
        altaEvidencia,
        pagoClientes,
        reporteCobranza,  
        configAdmin,
        configuracion,
        bancos,
        cambiaPrecios,
        menuCalidad,
        calidadCantidad,
        calidadImportes,
        menuAnticipos,
        anticiposCreate,
        abonos,
        abonosCreate,
        notasCargo,
        notasCargoCreate,
        bonificaciones,
        bonificacionesCreate,
        comisiones,
        comisionesCreate,
        muestrasEntrada,
        muestrasEntradaCreate,
        muestrasSalida,
        muestrasSalidaCreate,
        pagoProveedores,
        pagoProveedoresCreate,
        edoCtaProveedores,
        ajustesInventario,
        autorizarAjustesInventario,
        menu_fiscal,
        facturasFiscal,
        compPagosFiscal,
        devolucionesFiscal,
        notasCreditoFiscal,
        menu_empresas,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      togglePermisos();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
     .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

  return (
    <>
    <Header />
    <br />
    {user.menu_usuarios  ?(
        <div className="row">
        {
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h3 align="center">Usuarios</h3>
                <div className="row">
                        <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-6 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
                    <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Activo</Label>
                  <Input
                    type="select"
                    value={selectedStatus}
                    required
                    onChange={(e) => {
                      setSelectedStatus(e.target.value);
                    }}
                  >
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                    </Input>
                </Col>
              </Row>
            <Table size="sm" striped borderless className="table-responsive-xl">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                    <tbody>
                    {commentsData
                    .map((p) => {
                        // if (p.menu_edoCta_Fam == false && p.menu_edoCta_Cliente == false && p.email != "admin@lynqro.com") {
                      return (
                        <tr>
                          <td>{p.is_active}</td>
                          <td>{p.nombre}</td>
                          <td>{p.apellido}</td>
                          <td>{p.email}</td>
                          <td>
                          {user.usuarios_create?(
                          <Button color="info" id="Editar" size="sm" onClick={e=>{Edit(p._id, p.nombre, p.apellido, p.email)}}>
                            <i class="far fa-edit"></i>
                          </Button>
                        ):(
                          <Button color="info" id="Editar" size="sm" disabled>
                            <i class="far fa-edit"></i>
                          </Button>
                        )}
                            {user.usuarios_permisos  && user.is_active =="Si" ?(
                            <Button color="success" id="Permisos" size="sm" onClick={e=>{Permisos(
                              p._id, 
                              p.nombre,
                              p.apellido,
                              p.menu_planteles,
                              p.menu_areas,
                              p.menu_admin,
                              p.estado_cuenta_vendedores,
                              p.menu_proveedores,
                              p.proveedores_create,
                              p.menu_gastos,
                              p.gastos_create,
                              p.gastos_autorizar,
                              p.menu_clientes,
                              p.clientes_create,
                              p.clientes_edo_cta,
                              p.menu_catalogos,
                              p.menu_nominas,
                              p.menu_empleados,
                              p.empleados_create,
                              p.empleados_sueldo,
                              p.menu_puestos,
                              p.puestos_create,
                              p.nominas_create,
                              p.nominas_listado,
                              p.nominas_pagos_esp,
                              p.nominas_pagar,
                              p.menu_reportes,
                              p.menu_ingresos,
                              p.menu_egresos,
                              p.menu_usuarios,
                              p.usuarios_create,
                              p.usuarios_permisos,
                              p.menu_logs,
                              p.tipos_telas_create,
                              p.menu_tipos_telas,
                              p.colores_create,
                              p.menu_colores,
                              p.menu_cobradores,
                              p.menu_edoCta_Cliente,
                              p.menu_articulos,
                              p.articulos_create,
                              p.menu_inventarios,
                              p.menu_procesos,
                              p.inventarios,
                              p.menu_traspasos_salida,
                              p.traspasos_salida_create,
                              p.cancelar_traspaso_salida,
                              p.menu_traspasos_entrada,
                              p.traspasos_entrada_create,
                              p.menu_compras,
                              p.menu_oc,
                              p.oc_create,
                              p.compras,
                              p.compras_create,
                              p.menu_ventas,
                              p.ventas_create,
                              p.menu_pedidos,
                              p.pedidos_create,
                              p.pedidos_autorizar,
                              p.menu_devoluciones,
                              p.menu_devolucionesAdmin,
                              p.devoluciones_create,
                              p.menu_disponible,
                              p.disponible_vendedores,
                              p.menu_surtidos,
                              p.surtidos_create,
                              p.pendiente_recibir,
                              p.pendiente_embarcar,
                              p.embarques,
                              p.faltas_empleados,
                              p.seguimiento_inventarios,
                              p.grupos,
                              p.proyeccionEgresos,
                              p.edoCtaClientes,
                              p.cancelarNotas,
                              p.proyeccionIngresos,
                              p.altaEvidencia,
                              p.pagoClientes,
                              p.reporteCobranza,
                              p.configAdmin,
                              p.configuracion,
                              p.bancos,
                              p.cambiaPrecios,
                              p.menuCalidad,
                              p.calidadCantidad,
                              p.calidadImportes,
                              p.menuAnticipos,
                              p.anticiposCreate,
                              p.abonos,
                              p.abonosCreate,
                              p.notasCargo,
                              p.notasCargoCreate,
                              p.bonificaciones,
                              p.bonificacionesCreate,
                              p.comisiones,
                              p.comisionesCreate,
                              p.muestrasEntrada,
                              p.muestrasEntradaCreate,
                              p.muestrasSalida,
                              p.muestrasSalidaCreate,
                              p.pagoProveedores,
                              p.pagoProveedoresCreate,
                              p.edoCtaProveedores,
                              p.ajustesInventario,
                              p.autorizarAjustesInventario,
                              p.menu_fiscal,
                              p.facturasFiscal,
                              p.compPagosFiscal,
                              p.devolucionesFiscal,
                              p.notasCreditoFiscal,
                              p.menu_empresas,
                              )}}>
                            <i class="fas fa-key"></i>{" "}
                          </Button>
                            ):(
                              <Button color="success" id="Permisos" size="sm" disabled>
                            <i class="fas fa-key"></i>{" "}
                          </Button>
                            )}
                            {user.usuarios_create?(
                          <Baja
                            idStatus={p._id}
                            is_active={p.is_active}
                            URL_BAJA={process.env.REACT_APP_URL_USERS}
                          />
                            ):undefined}
                          </td>
                        </tr>
                      );
                      // }
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        }
        {/* <div className="col-4">
          <div className="card">
            <div className="card-body">
              <Signup />
            </div>
          </div>
        </div> */}
        </div>
      ): undefined } 

<Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}><h4>Editar Usuario {nombre} {apellido} </h4></ModalHeader>
        <ModalBody>
          {/* <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={nombre}
            required
            onChange={(e) => {
              setNombre(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Apellido</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={apellido}
            required
            onChange={(e) => {
              setApellido(e.target.value);
            }}
          />
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={email}
            required
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          /> */}
              <Label className="mr-sm-2">Almacen</Label>
                <Input
                  type="select"
                  value={area}
                  required
                  onChange={(e) => setArea(e.target.value)}
                >
                  <option value="0">Selecciona</option>
                  {areas
                    .sort((a, b) => a.name - b.name)
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input> 
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editUsuario}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* //Permisos */}
      <Modal size="xxl" isOpen={modalPermisos} toggle={togglePermisos}>
        <ModalHeader toggle={togglePermisos}><h4>Permisos de {nombre} {apellido} </h4></ModalHeader>
        <ModalBody>
        {(() => {
          const GRUPOS_PERM = [
  {
    titulo: "Articulos", icono: "fas fa-box", color: "#3b82f6", bg: "#eff6ff",
    items: [
      { k: "menu_articulos", v: menu_articulos, set: setMenuArticulos, label: "Articulos" },
      { k: "articulos_create", v: articulos_create, set: setArticulosCreate, label: "Crear Articulos" },
    ],
  },
  {
    titulo: "Compras e Importacion", icono: "fas fa-shopping-cart", color: "#f59e0b", bg: "#fffbeb",
    items: [
      { k: "menu_compras", v: menu_compras, set: setMenuCompras, label: "Compras" },
      { k: "menu_oc", v: menu_oc, set: setMenuOC, label: "PO" },
      { k: "menu_proveedores", v: menu_proveedores, set: setMenuProveedores, label: "Proveedores" },
      { k: "proveedores_create", v: proveedores_create, set: setProveedoresCreate, label: "Crear Proveedores" },
      { k: "pendiente_embarcar", v: pendiente_embarcar, set: setPendienteEmbarcar, label: "Pendiente Embarcar" },
      { k: "pendiente_recibir", v: pendiente_recibir, set: setPendienteRecibir, label: "Pendiente Recibir" },
      { k: "embarques", v: embarques, set: setEmbarques, label: "Embarques" },
      { k: "menuCalidad", v: menuCalidad, set: setMenuCalidad, label: "Control Calidad" },
      { k: "calidadCantidad", v: calidadCantidad, set: setCalidadCantidad, label: "Control Calidad Cantidades" },
      { k: "calidadImportes", v: calidadImportes, set: setCalidadImportes, label: "Control Calidad Importes" },
    ],
  },
  {
    titulo: "Produccion", icono: "fas fa-industry", color: "#6366f1", bg: "#eef2ff",
    items: [
      { k: "menu_procesos", v: menu_procesos, set: setMenuProcesos, label: "Menu Produccion / Maquilas" },
    ],
  },
  {
    titulo: "Ventas", icono: "fas fa-cash-register", color: "#10b981", bg: "#f0fdf4",
    items: [
      { k: "menu_ventas", v: menu_ventas, set: setMenuVentas, label: "Menu Ventas" },
      { k: "menu_pedidos", v: menu_pedidos, set: setMenuPedidos, label: "Pedidos" },
      { k: "pedidos_create", v: pedidos_create, set: setPedidosCreate, label: "Crear Pedidos" },
      { k: "pedidos_autorizar", v: pedidos_autorizar, set: setPedidosAutorizar, label: "Autorizar Pedidos" },
      { k: "menu_surtidos", v: menu_surtidos, set: setMenuSurtidos, label: "Notas" },
      { k: "surtidos_create", v: surtidos_create, set: setSurtidosCreate, label: "Crear Notas" },
      { k: "menu_devoluciones", v: menu_devoluciones, set: setMenuDevoluciones, label: "Devoluciones" },
      { k: "devoluciones_create", v: devoluciones_create, set: setDevolucionesCreate, label: "Crear Devoluciones" },
      { k: "menu_clientes", v: menu_clientes, set: setMenuClientes, label: "Clientes" },
      { k: "clientes_create", v: clientes_create, set: setClientesCreate, label: "Crear Clientes" },
      { k: "grupos", v: grupos, set: setGrupos, label: "Grupos" },
      { k: "cambiaPrecios", v: cambiaPrecios, set: setCambiaPrecios, label: "Cambiar Precios" },
      { k: "altaEvidencia", v: altaEvidencia, set: setAltaEvidencia, label: "AltaEvidencia" },
      { k: "menu_devolucionesAdmin", v: menu_devolucionesAdmin, set: setMenuDevolucionesAdmin, label: "Devoluciones Admin" },
    ],
  },
  {
    titulo: "Inventarios", icono: "fas fa-boxes", color: "#14b8a6", bg: "#f0fdfa",
    items: [
      { k: "menu_inventarios", v: menu_inventarios, set: setMenuInventarios, label: "Menu Inventarios" },
      { k: "inventarios", v: inventarios, set: setInventarios, label: "Inventarios" },
      { k: "seguimiento_inventarios", v: seguimiento_inventarios, set: setSeguimientoInventarios, label: "Seguimiento Inventarios" },
      { k: "menu_disponible", v: menu_disponible, set: setMenuDisponible, label: "Disponible" },
      { k: "disponible_vendedores", v: disponible_vendedores, set: setDisponibleVendedores, label: "Disponible Vendedores" },
      { k: "menu_traspasos_salida", v: menu_traspasos_salida, set: setMenuTraspasosSalida, label: "Menu Traspasos Salida" },
      { k: "traspasos_salida_create", v: traspasos_salida_create, set: setTraspasosSalidaCreate, label: "Crear Traspasos Salida" },
      { k: "cancelar_traspaso_salida", v: cancelar_traspaso_salida, set: setCancelarTraspasoSalida, label: "Cancelar Traspasos Salida" },
      { k: "menu_traspasos_entrada", v: menu_traspasos_entrada, set: setMenuTraspasosEntrada, label: "Menu Traspasos Entrada" },
      { k: "traspasos_entrada_create", v: traspasos_entrada_create, set: setTraspasosEntradaCreate, label: "Crear Traspasos Entrada" },
      { k: "ajustesInventario", v: ajustesInventario, set: setAjustesInventario, label: "Ajuste Inventario" },
      { k: "autorizarAjustesInventario", v: autorizarAjustesInventario, set: setAutorizarAjustesInventario, label: "Autorizar Ajuste Inventario" },
      { k: "muestrasEntrada", v: muestrasEntrada, set: setMuestrasEntrada, label: "Entrada de Muestras" },
      { k: "muestrasEntradaCreate", v: muestrasEntradaCreate, set: setMuestrasEntradaCreate, label: "Crear Entrada de Muestras" },
      { k: "muestrasSalida", v: muestrasSalida, set: setMuestrasSalida, label: "Salida de Muestras" },
      { k: "muestrasSalidaCreate", v: muestrasSalidaCreate, set: setMuestrasSalidaCreate, label: "Crear Salida de Muestras" },
    ],
  },
  {
    titulo: "Administracion", icono: "fas fa-hand-holding-usd", color: "#8b5cf6", bg: "#f5f3ff",
    items: [
      { k: "configAdmin", v: configAdmin, set: setConfigAdmin, label: "Menu Admin" },
      { k: "bancos", v: bancos, set: setBancos, label: "Bancos" },
      { k: "abonos", v: abonos, set: setAbonos, label: "Abonos" },
      { k: "abonosCreate", v: abonosCreate, set: setAbonosCreate, label: "Crear Abonos" },
      { k: "menuAnticipos", v: menuAnticipos, set: setMenuAnticipos, label: "Anticipos" },
      { k: "anticiposCreate", v: anticiposCreate, set: setAnticiposCreate, label: "Crear Anticipos" },
      { k: "notasCargo", v: notasCargo, set: setNotasCargo, label: "Notas de Cargo" },
      { k: "notasCargoCreate", v: notasCargoCreate, set: setNotasCargoCreate, label: "Crear Notas de Cargo" },
      { k: "comisiones", v: comisiones, set: setComisiones, label: "Comisiones" },
      { k: "comisionesCreate", v: comisionesCreate, set: setComisionesCreate, label: "Crear Comisiones" },
      { k: "edoCtaClientes", v: edoCtaClientes, set: setEdoCtaClientes, label: "Estado Cuenta Clientes" },
    ],
  },
  {
    titulo: "Cuentas por Pagar", icono: "fas fa-file-invoice", color: "#f43f5e", bg: "#fff1f2",
    items: [
      { k: "pagoProveedores", v: pagoProveedores, set: setPagoProveedores, label: "Pago Proveedores" },
      { k: "edoCtaProveedores", v: edoCtaProveedores, set: setEdoCtaProveedores, label: "Estado Cuenta Proveedores" },
    ],
  },
  {
    titulo: "Gastos", icono: "fas fa-wallet", color: "#0ea5e9", bg: "#f0f9ff",
    items: [
      { k: "menu_gastos", v: menu_gastos, set: setMenuGastos, label: "Menu Gastos" },
    ],
  },
  {
    titulo: "Fiscal", icono: "fas fa-file-invoice-dollar", color: "#8b5cf6", bg: "#f5f3ff",
    items: [
      { k: "menu_fiscal", v: menu_fiscal, set: setMenuFiscal, label: "Menu Fiscal" },
      { k: "facturasFiscal", v: facturasFiscal, set: setFacturasFiscal, label: "Facturas" },
      { k: "compPagosFiscal", v: compPagosFiscal, set: setCompPagosFiscal, label: "Complementos de Pagos" },
      { k: "devolucionesFiscal", v: devolucionesFiscal, set: setDevolucionesFiscal, label: "Devoluciones" },
      { k: "notasCreditoFiscal", v: notasCreditoFiscal, set: setNotasCreditoFiscal, label: "Notas Credito" },
    ],
  },
  {
    titulo: "Empleados", icono: "fas fa-users", color: "#10b981", bg: "#f0fdf4",
    items: [
      { k: "menu_empleados", v: menu_empleados, set: setMenuEmpleados, label: "Empleados" },
      { k: "empleados_create", v: empleados_create, set: setEmpleadosCreate, label: "Crear Empleados" },
      { k: "empleados_sueldo", v: empleados_sueldo, set: setEmpleadosSueldo, label: "Sueldo Empleados" },
      { k: "faltas_empleados", v: faltas_empleados, set: setFaltasEmpleados, label: "Faltas" },
      { k: "menu_puestos", v: menu_puestos, set: setMenuPuestos, label: "Menu Puestos" },
      { k: "puestos_create", v: puestos_create, set: setPuestosCreate, label: "Crear Puestos" },
      { k: "nominas_create", v: nominas_create, set: setNominasCreate, label: "Crear Nominas" },
      { k: "nominas_listado", v: nominas_listado, set: setNominasListado, label: "Nominas" },
      { k: "nominas_pagos_esp", v: nominas_pagos_esp, set: setNominasPagosEsp, label: "Pagos Especiales" },
      { k: "nominas_pagar", v: nominas_pagar, set: setNominasPagar, label: "Pagar Nominas" },
    ],
  },
  {
    titulo: "Catalogos", icono: "fas fa-clipboard-list", color: "#6366f1", bg: "#eef2ff",
    items: [
      { k: "menu_admin", v: menu_admin, set: setMenuAdmin, label: "Gastos" },
      { k: "menu_areas", v: menu_areas, set: setMenuAreas, label: "Almacenes" },
      { k: "menu_planteles", v: menu_planteles, set: setMenuPlanteles, label: "Planteles" },
    ],
  },
  {
    titulo: "Reportes", icono: "fas fa-chart-bar", color: "#0ea5e9", bg: "#f0f9ff",
    items: [
      { k: "menu_reportes", v: menu_reportes, set: setMenuReportes, label: "Reportes" },
    ],
  },
  {
    titulo: "Sistema", icono: "fas fa-user-cog", color: "#64748b", bg: "#f1f5f9",
    items: [
      { k: "menu_usuarios", v: menu_usuarios, set: setMenuUsuarios, label: "Menu Usuarios" },
      { k: "usuarios_create", v: usuarios_create, set: setUsuariosCreate, label: "Crear Usuarios" },
      { k: "usuarios_permisos", v: usuarios_permisos, set: setUsuariosPermisos, label: "Permisos Usuarios" },
      { k: "menu_logs", v: menu_logs, set: setMenuLogs, label: "Menu Logs" },
      { k: "configuracion", v: configuracion, set: setConfiguracion, label: "Config" },
    ],
  },
          ];
          const totalPerm = GRUPOS_PERM.reduce((n, g) => n + g.items.length, 0);
          const activos = GRUPOS_PERM.reduce((n, g) => n + g.items.filter((i) => i.v).length, 0);
          const todoGeneral = (val) => GRUPOS_PERM.forEach((g) => g.items.forEach((i) => i.set(val)));
          return (
            <>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", marginBottom: 14,
                          background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10 }}>
              <i className="fas fa-user-shield" style={{ color: "#6366f1" }} />
              <span style={{ fontWeight: 700, fontSize: "0.85rem", color: "#0f172a" }}>
                {activos} de {totalPerm} permisos activos
              </span>
              <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                <Button size="sm" color="primary" outline onClick={() => todoGeneral(true)}>
                  Seleccionar todo
                </Button>
                <Button size="sm" color="secondary" outline onClick={() => todoGeneral(false)}>
                  Quitar todo
                </Button>
              </div>
            </div>
            <div className="row">
              {GRUPOS_PERM.map((g) => (
                <div className="col-12 col-md-6 col-xl-4 mb-3" key={g.titulo}>
                  <div style={{ background: "#fff", border: "1px solid #f1f5f9", borderRadius: 10, boxShadow: "0 1px 3px rgba(0,0,0,0.07)", height: "100%" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", borderBottom: "1px solid #f1f5f9" }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: g.bg, display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${g.color}40` }}>
                        <i className={g.icono} style={{ color: g.color, fontSize: "0.9rem" }} />
                      </div>
                      <span style={{ fontWeight: 700, fontSize: "0.82rem", color: "#0f172a" }}>{g.titulo}</span>
                      <span style={{ marginLeft: "auto", fontSize: "0.68rem", color: "#94a3b8" }}>
                        {g.items.filter((i) => i.v).length}/{g.items.length}
                      </span>
                      <input
                        type="checkbox"
                        title="Seleccionar toda la seccion"
                        checked={g.items.every((i) => i.v)}
                        onChange={(e) => g.items.forEach((i) => i.set(e.currentTarget.checked))}
                        style={{ accentColor: g.color, width: 16, height: 16, cursor: "pointer" }}
                      />
                    </div>
                    <div style={{ padding: "8px 14px 12px" }}>
                      {g.items.map((i) => (
                        <label key={i.k} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 0", margin: 0, cursor: "pointer", fontSize: "0.78rem", color: i.v ? "#0f172a" : "#64748b" }}>
                          <input type="checkbox" checked={!!i.v} onChange={(e) => i.set(e.currentTarget.checked)} style={{ accentColor: g.color, width: 15, height: 15, cursor: "pointer" }} />
                          <span>{i.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            </>
          );
        })()}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={permisosUsuario}>Guardar</Button>
          <Button color="secondary" onClick={togglePermisos}>Cancelar</Button>
        </ModalFooter>
      </Modal>

{loader}
    </>
  );
}

export default ListadoUsuarios;
